import { useQuery } from '@tanstack/react-query';

import { fetchClosedTicketsApi } from './api';
import { ClosedTicketsParams } from './ClosedTickets.types';

/*
 * One page at a time from our own copy of GlobeMed's closed claims, which
 * changes once a night, so a page is kept for a minute.
 */
export default function useClosedTicketsQuery(params: ClosedTicketsParams) {
  return useQuery(['healthClaims', 'closed', params], fetchClosedTicketsApi, {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
